/*******************************************************************************
  SiteConfigSection.js

  Author: Advait

*******************************************************************************/

import React from 'react'
import { API } from 'aws-amplify'
import { useDispatch, useSelector } from "react-redux"
import { selectSite, updateSite as updateSiteInStore } from '../store/siteSlice'
import SiteConfigForm from './SiteConfigForm'
import { updateSite } from '../apihelpers/graphqlhelpers'
import { showNotification } from '../components/helper/notification';
import '../index.css'

//***************************************************************************
// This component handles configuring various attributes of a site.
//***************************************************************************
function SiteConfigSection() {
    const dispatch = useDispatch();
    const isSysAdmin = useSelector(state=>state.user.sysAdmin)
    const selectedSite = useSelector(selectSite);

    /**
     * called when user clicks Save in the form
     */
    async function handleFormSave(fields) {
        // Update site configuration in the database
        try{
          const response = await updateSite(isSysAdmin, fields);   
          showNotification(response);          
          dispatch(updateSiteInStore(response.data.updateSite));
          // The API response does not have these fields, so udpate
          // them separately after a successful response.
          dispatch(updateSiteInStore({
            id: fields.id,
            adminEmailsToNotify: fields.adminEmailsToNotify,
            rmsUser: fields.rmsUser,
          }));
        }catch{
          showNotification();
        }
        // if time zone changed, tell task manager it should update the schedule
        if (selectedSite.timezone !== fields.timezone) {
            API.post('fataskman', '/sites/' + selectedSite.id, { body: { action: "update_schedule" } })
            .catch((err)=> console.log(err));
        }
    }

    //***************************************************************************
    // render the UI
    //***************************************************************************
    return (
      <div>
        {selectedSite ?
        <SiteConfigForm
          // Key forces a separate component for each site, don't try to re-use
          // an existing component when we switch sites.
          key={selectedSite.id}
          onSave={handleFormSave}
        /> : null}
      </div>
    )
}
export default SiteConfigSection